<template>
  <v-dialog v-model="visible" persistent :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-tabs class="mb-2" v-model="tab" :color="Theme.GREEN">
          <v-tab :value="0">商品資訊</v-tab>
          <v-tab :value="1">商品介紹</v-tab>
          <v-tab :value="2">商品圖片</v-tab>
          <v-tab :value="3">詳細圖片</v-tab>
          <v-tab v-if="itemDetail.type === 1" :value="4">購買連結</v-tab>
        </v-tabs>
        <div v-if="tab === 0 || tab === 1 || tab === 2">
          <v-layout v-for="col in getDialogKeys" :key="col.value">
            <v-flex>
              <quill-editor
                v-if="col.value === 'content'"
                class="mb-2 mt-2"
                ref="myQuillEditor"
                v-model="itemDetail[col.value]"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
              />
              <v-textarea
                v-else-if="col.value === 'introduction'"
                :label="col.text"
                :color="Theme.GREEN"
                v-model="itemDetail[col.value]"
              />
              <v-select
                v-else-if="col.options && !col.isMultiple"
                :color="Theme.GREEN"
                :items="col.options"
                :label="col.text"
                item-text="text"
                item-value="key"
                v-model="itemDetail[col.value]"
              />
              <v-select
                v-else-if="col.isMultiple && col.value === 'counter'"
                :color="Theme.GREEN"
                :items="col.options"
                :label="col.text"
                item-text="name"
                item-value="counterId"
                v-model="itemDetail[col.value]"
                multiple
              />
              <v-text-field
                v-else
                v-model="itemDetail[col.value]"
                :label="col.text"
                :color="Theme.GREEN"
              ></v-text-field>
              <img
                style="width: 25%;"
                v-if="col.isImage"
                :src="itemDetail[col.value]"
              />
            </v-flex>
          </v-layout>
        </div>

        <v-layout v-if="tab === 3">
          <v-flex>
            <v-btn dark :color="Theme.GREEN" @click="addImage">新增</v-btn>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 3" row>
          <v-flex>
            <v-card
              v-for="(image, i) in itemDetail.imageList"
              :key="i"
              class="mt-1"
            >
              <v-card-text>
                <v-text-field
                  v-model="image.url"
                  :label="`#${i + 1} 網址`"
                  :color="Theme.GREEN"
                ></v-text-field>
                <v-layout class="ma-1">
                  <v-flex>
                    <v-text-field
                      v-model="image.note"
                      label="備註"
                      :color="Theme.GREEN"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="ma-1">
                  <v-flex xs6>
                    <v-text-field
                      v-model="image.sort"
                      label="排序"
                      :color="Theme.GREEN"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn :color="Theme.PINK" dark @click="deleteImage(i)"
                      >刪除</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout v-if="tab === 4 && itemDetail.type === 1">
          <v-flex>
            <v-btn dark :color="Theme.GREEN" @click="addLink">新增</v-btn>
          </v-flex>
        </v-layout>
        <v-layout class="mt-2" v-if="tab === 4 && itemDetail.type === 1" row>
          <v-flex>
            <v-card
              v-for="(image, i) in itemDetail.linkList"
              :key="i"
              class="mt-1"
            >
              <v-card-text>
                <v-text-field
                  v-model="image.url"
                  :label="`#${i + 1} 網址`"
                  :color="Theme.GREEN"
                ></v-text-field>
                <v-layout class="ma-1">
                  <v-flex xs6>
                    <v-text-field
                      v-model="image.title"
                      label="標題"
                      :color="Theme.GREEN"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn :color="Theme.PINK" dark @click="deleteLink(i)"
                      >刪除</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent"
          >取消</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          dark
          :color="Theme.GREEN"
          :loading="saveLoading"
          @click="confirmEvent"
          >確定</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";

export default {
  name: "product_detail",
  mixins: [common],
  props: {
    title: String,
    itemDetail: Object,
    counters: Array,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      saveLoading: false,
      content: "",
      editorOption: {
        placeholder: "商品詳細介紹",
      },
      tab: 0,
      defaultImageItem: {
        productId: "",
        url: "",
        sort: 0,
        createdDate: new Date(),
        type: 0,
        note: "",
      },
      defaultLinkItem: {
        productId: "",
        title: "",
        url: "",
        createdDate: new Date(),
      },
    };
  },
  watch: {
    "itemDetail.category": function(value) {
      if (value === 2 || value === 3 || value === 4) {
        this.itemDetail.disposable = -1;
        this.itemDetail.baseCurve = "0";
        this.itemDetail.diameter = "0";
        this.itemDetail.waterContent = "0";
      } else {
        this.itemDetail.disposable = 0;
        this.itemDetail.baseCurve = this.itemDetail.baseCurve
          ? this.itemDetail.baseCurve
          : "8.6mm";
        this.itemDetail.diameter = this.itemDetail.diameter
          ? this.itemDetail.diameter
          : "14.0mm";
        this.itemDetail.waterContent = this.itemDetail.waterContent
          ? this.itemDetail.waterContent
          : "38%";
      }
    },
  },
  created() {},
  mounted() {
    console.log("this is current quill instance object", this.editor);
  },
  computed: {
    editor() {
      if (this.$refs.myQuillEditor) {
        return this.$refs.myQuillEditor.quill;
      }
      return null;
    },
    getDialogKeys() {
      console.log(`getCounterData ${JSON.stringify(this.counters)}`);
      let list = [
        { value: "productId", text: "商品編號" },
        { value: "type", text: "分類", options: this.getProductTypes },
        { value: "productGroup", text: "整系列" },
        { value: "name", text: "商品名稱" },
        {
          value: "enable",
          text: "上架狀態",
          options: this.getProductEnable,
        },
        {
          value: "category",
          text: "類型",
          options: this.getProductCategoryList,
        },
        { value: "color", text: "顏色" },

        { value: "sort", text: "排序" },
        { value: "disposable", text: "週期", options: this.getDisposableList },
        { value: "baseCurve", text: "基弧", options: this.getBaseCurveList },
        {
          value: "waterContent",
          text: "含水量",
          options: this.getWaterContentList,
        },
        { value: "diameter", text: "直徑", options: this.getDiameterList },
        { value: "price", text: "售價" },
        { value: "unit", text: "單位" },
        { value: "introduction", text: "簡介" },
        { value: "content", text: "詳細介紹" },
        { value: "smallURL", text: "小圖網址", isImage: true },
        { value: "smallHoverURL", text: "小圖變換網址", isImage: true },
        { value: "largeURL", text: "大圖網址", isImage: true },
        { value: "largeHoverURL", text: "大圖變換網址", isImage: true },
        { value: "simpleProduct", text: "簡易商品名" },
        {
          value: "counter",
          text: "櫃位",
          options: this.counters,
          isMultiple: true,
        },
        // {value: 'imagesList', text: '詳細圖'},
        // {value: 'pcDetailURL', text: '電腦版詳細圖網址', isImage: true},
        // {value: 'mobileDetailURL', text: '手機詳細圖網址', isImage: true},
      ];
      if (this.tab === 1) {
        return list.filter(
          (m) => m.value === "content" || m.value === "introduction"
        );
      } else if (this.tab === 2) {
        return list.filter(
          (m) =>
            m.value === "smallURL" ||
            m.value === "smallHoverURL" ||
            m.value === "largeURL" ||
            m.value === "largeHoverURL" ||
            m.value === "pcDetailURL" ||
            m.value === "mobileDetailURL"
        );
      } else {
        return list.filter(
          (m) =>
            m.value !== "content" &&
            m.value !== "introduction" &&
            m.value !== "smallURL" &&
            m.value !== "smallHoverURL" &&
            m.value !== "largeURL" &&
            m.value !== "largeHoverURL" &&
            m.value !== "pcDetailURL" &&
            m.value !== "mobileDetailURL"
        );
      }
    },
  },
  methods: {
    ...mapActions(["saveProductInfo"]),
    addImage() {
      const image = Object.assign({}, this.defaultImageItem);
      image.productId = this.itemDetail.productId;
      this.itemDetail.imageList.push(image);
    },
    addLink() {
      const link = Object.assign({}, this.defaultLinkItem);
      link.productId = this.itemDetail.productId;
      this.itemDetail.linkList.push(link);
    },
    deleteImage(i) {
      this.itemDetail.imageList.splice(i, 1);
    },
    deleteLink(i) {
      this.itemDetail.linkList.splice(i, 1);
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
      quill.container.style.height = "500px";
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    async confirmEvent() {
      this.saveLoading = true;

      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveProductInfo({
        token: "",
        info: this.itemDetail,
      });
      const result = res.data;
      if (result.code === 0) {
        this.$emit("confirmEvent", this.itemDetail);
      } else {
        this.showMessageDialog(
          "錯誤",
          result.message ? result.result : "儲存失敗"
        );
      }
      this.saveLoading = false;
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        confirmEvent: async () => {
          this.hideAlert();
        },
      });
    },
  },
};
</script>

<style scoped></style>
